export default __webpack_public_path__ + "static/media/icon-rato.330f8cc2.svg";